<div class="flex items-center justify-center">
  @if (styleSheet.themeId) {
    @if (styleSheet.isThemeDefault) {
      <mat-icon class="!m-0 !text-accent" svgIcon="icon_star" />
    } @else if (showNoIconPlaceholder) {
      <div class="w-[var(--icon-size)] h-[var(--icon-size)]"></div>
    }
  } @else {
    <mat-icon class="!m-0 !text-primary-lighter" svgIcon="icon_ds_globals" />
  }
</div>
